import GraphQL from "../../api/graphql";
import { make } from "vuex-pathify";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import isString from "lodash/isString";

const state = {
    currentTerm: "",
    currentPage: 1,
    filters: {
        audio: false,
        video: false,
        document: false,
        image: false,
        startDate: null,
        endDate: null
    },
    lastSearch: {},
    pageCount: 0,
    total: 0,
    results: [],
    selectedAccessLevel: null,
    selectedUsers: [],
    lastSeen: [],
    fonds: [],
    levels: [],
    levels_id: '',
    levels_name: '',
    levels_fathers: false,
    levels_father_name: false,
    levels_father_id: false,
    levels_itens: false,
    levels_itens_id: '',
    levels_itens_name: '',
    levels_sons: [],
    is_document_favorite: false,
    isSyncRunning: false,
    favorite_list: [],
    favorite_list_ids: [],
    search_in_folder: false,
};

const DEFAULT_FILTERS = {
    audio: false,
    video: false,
    document: false,
    image: false,
    startDate: null,
    endDate: null
};

const ACCESS_Fonds = {
    administrator: "ADMINISTRATOR",
    restrict: "RESTRICT",
    specific_restrict: "SPECIFIC_RESTRICTION",
    public: "PUBLIC"
};

const DEFAULT_DESCRIPTION = "Sem descrição";

const DEFAULT_TITLE = "Sem título";

const mutations = make.mutations(state);

const actions = {
    async search({ state, rootState }) {
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        var result = [];
        this.set("search/results", result);
        this.set("search/search_in_folder", false);

        var term = state.currentTerm;
        const page = state.currentPage;

        term = term.replace(/"/g,"'");

        let filters = { ...state.filters };
        filters.startDate = formatDate(filters.startDate);
        filters.endDate = formatDate(filters.endDate);

        const response = await client.query({
            query: `
                {
                    getDocumentsAndFoldersByName(name: "${term}") {
                        id,
                        acervo_id
                        name,
                        created_at
                    }
                }
            `,
            variables: {
                term
            }
        });

        const lastSearch = {
            currentTerm: 1,
            filters: false,
            currentPage: 1
        };

        this.set("search/results", response.data.getDocumentsAndFoldersByName);
        this.set("search/lastSearch", lastSearch);
    },
    async submitDocumentRequest(
        { state, rootState },
        { documentName, documentId }
    ) {
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const response = await client.query({
            query: `
                mutation($documentId: ID!, $documentName: String!, $accessLevel: AccessLevelEnum!, $users: [ID!]) {
                    requestDocumentPermission(document_id: $documentId, document_name: $documentName, access_level: $accessLevel, users: $users)
                }
            `,
            variables: {
                documentId,
                documentName,
                users: state.selectedUsers,
                accessLevel: ACCESS_Fonds[state.selectedAccessLevel]
            }
        });

        return response.data.requestDocumentPermission;
    },
    async runSync({ state, rootState }) {
        if (state.isSyncRunning) {
            return;
        }

        this.set("search/isSyncRunning", true);

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        await client.query({
            query: `
                mutation {
                    syncAristoteles
                }
            `,
            variables: {}
        });

        this.set("search/isSyncRunning", false);
    },
    async getSeenLast({ rootState }) {
        var list = [];
        this.set("search/lastSeen", list);
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const response = await client.query({
            query: `{
                userSeen {
                    item_id,
                    created_at,
                    name,
                    folder,
                    shared_with,
                    type,
                    favorite
                }
            }`
        });
        if (response.data.userSeen.length > 0) {
            this.set("search/lastSeen", response.data.userSeen);
        }
    },
    async setSeenLast({ rootState },  payload = {}) {
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const item_id = payload.item_id;
        const shared_with = payload.shared_with;
        const name = payload.name;
        const folder = payload.folder;
        const type = payload.type;

        await client.query({
            query: `{
                setUserSeen(
                    item_id: ${item_id},
                    shared_with: "${shared_with}",
                    name: "${name}",
                    folder: "${folder}",
                    type: "${type}"
                )
            }`,
            variables: {
                item_id,
                shared_with,
                name,
                folder,
                type
            }
        });
    },
    async getFonds({rootState}) {
        var list = [];
        this.set("search/fonds", list);

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const response = await client.query({
            query: `{
                getFonds(id: ${-1}) {
                    id,
                    name,
                    acervo_id
                }
            }`
        });

        if (response.data.getFonds.length > 0) {
            this.set("search/fonds", response.data.getFonds);
        }

    },
    async getLevels({rootState}, payload = {}) {
        var list = false;
        this.set("search/levels", list);
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const id = parseInt(payload.id);
        const response = await client.query({
            query: `{
                getFonds(id: ${id}) {
                    folders {
                        id,
                        name,
                        acervo_id,
                        parent_folder_id, 
                        parent_fund_id
                    }
                }
            }`,
            variables: {
                id
            }
        });
        
        if (response.data.getFonds[0].folders.length) {
            this.set("search/levels", response.data.getFonds[0].folders);
        }
        this.set("search/levels", response.data.getFonds[0].folders);

        this.set("search/levels_id", payload.id);
        this.set("search/levels_name", payload.name);
    },
    async GetLevelFather({rootState}, payload = {}) {
        var list = false;
        this.set("search/levels", list);
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const id = parseInt(payload.id);

        const response = await client.query({
            query: `{
                getLevelsFoldersByFolder(id: ${id}) {
                        fathers {
                            id,
                            name
                        }
                        fund {
                            id,
                            name
                        }
                    }
            }`,
            variables: {
                id
            }
        });

        if (response.data.getLevelsFoldersByFolder !== null) {
            this.set("search/levels_fathers", response.data.getLevelsFoldersByFolder.fathers);
            this.set("search/levels_name", response.data.getLevelsFoldersByFolder.fund.name);
            this.set("search/levels_id", response.data.getLevelsFoldersByFolder.fund.id);
        } else {
            this.set("search/levels_fathers", false);
            this.set("search/levels_name", false);
            this.set("search/levels_id", false);
        }
    },
    async getItens({rootState}, payload = {}) {
        var list = [];
        this.set("search/levels_itens", list);
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const id = parseInt(payload.id);

        const response = await client.query({
            query: `{
                getDocumentsAndFolders(id: ${id}) {
                    folders {
                        id,
                        name,
                        acervo_id,
                        parent_folder_id,
                        parent_fund_id
                    },
                    documents {
                        id,
                        name,
                        type,
                        acervo_id,
                        parent_folder_id
                    }
                }
            }`,
            variables: {
                id
            }
        });

        if (response.data.getDocumentsAndFolders[0].documents.length > 0) {
            this.set("search/levels_itens", response.data.getDocumentsAndFolders[0].documents);
        } else {
            list = [];
            this.set("search/levels_itens", list);
        }

        if (response.data.getDocumentsAndFolders[0].folders.length > 0) {
            this.set("search/levels_sons", response.data.getDocumentsAndFolders[0].folders);
        } else {
            list = [];
            this.set("search/levels_sons", list);
        }

        this.set("search/levels_itens_id", payload.id);
        this.set("search/levels_itens_name", payload.name);
    },
    async isDocumentFavorite({rootState}, payload = {}) {
        var result = false;
        this.set("search/is_document_favorite", result);

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const id = parseInt(payload.id);

        const response = await client.query({
            query: `{
                    isFavorite(id: ${id})
            }`,
            variables: {
                id
            }
        });

        if (response.data.isFavorite) {
            this.set("search/is_document_favorite", response.data.isFavorite);
        }
    },
    async getFavoritesIdList({rootState}, payload = {}) {
        var result = [];
        this.set("search/favorite_list", result);
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const response = await client.query({
            query: `{
                favorite
            }`
        });
        if (response.data.favorite.length > 0) {
            this.set("search/favorite_list", response.data.favorite);
        }
    },
    async getFavoritesUserIdList({rootState}, payload = {}) {
        var result = [];
        this.set("search/favorite_list_ids", result);
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const id = parseInt(payload.id);

        const response = await client.query({
            query: `{
                    favoriteId(id: ${id})
            }`,
            variables: {
                id
            }
        });
        if (response.data.favoriteId.length > 0) {
            this.set("search/favorite_list_ids", response.data.favoriteId);
        }
    },
    async searchByType({rootState}, payload = {}) {
        var types = [];
        var result = [];
        this.set("search/results", result);
        this.set("search/search_in_folder", false);

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        if (payload.types.document) {
            types.push('no-document');
        } 
        if (payload.types.video) {
            types.push('video');
        }
        if (payload.types.audio) {
            types.push('audio');
        }
        if (payload.types.image) {
            types.push('image');
        }

        var term = payload.term.toString();
        const page = payload.page;

        term = term.replace(/"/g,"'");

        this.set("search/currentTerm", term);

        const response = await client.query({
            query: `{
                getDocumentsByType(name: "${term}", types: "${types}", page: "${page}") {
                    total,
                    last_page,
                    current_page,
                    data {
                        name,
                        type,
                        acervo_id,
                        parent_folder_id,
                        created_at   
                    }
                }
            }`,
            variables: {
                term,
                types,
                page
            }
        });

        if (response.data.getDocumentsByType.data.length) {
            this.set("search/results", response.data.getDocumentsByType.data);
            this.set("search/pageCount", parseInt(response.data.getDocumentsByType.last_page));
            this.set("search/currentPage", parseInt(response.data.getDocumentsByType.current_page))
            this.set("search/total",  parseInt(response.data.getDocumentsByType.total))
        }

    },
    async searchFolder({rootState}, payload = {}) {
        var result = [];
        this.set("search/results", result);
        this.set("search/search_in_folder", true);

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        var term = payload.term.toString();
        const page = payload.page;

        term = term.replace(/"/g,"'");

        const response = await client.query({
            query: `{
                getFoldersByName(name: "${term}", page: "${page}") {
                    total,
                    last_page,
                    current_page,
                    data {    
                        id,
                        name,
                        acervo_id,
                        parent_folder_id,
                        parent_fund_id,
                        created_at
                    }
                }
            }`,
            variables: {
                term,
                page
            }
        });

        if (response.data.getFoldersByName.data.length) {
            this.set("search/results", response.data.getFoldersByName.data);
            this.set("search/pageCount", parseInt(response.data.getFoldersByName.last_page));
            this.set("search/currentPage", parseInt(response.data.getFoldersByName.current_page))
            this.set("search/total",  parseInt(response.data.getFoldersByName.total))
        }

    },
    reset() {
        this.set("search/currentTerm", "");
        this.set("search/filters", DEFAULT_FILTERS);
        this.set("search/pageCount", 0);
        this.set("search/results", []);
        this.set("search/selectedAccessLevel", null);
        this.set("search/selectedUsers", []);
        this.set("search/lastSearch", {});
        this.set("search/lastSeen", []);
        this.set("search/fonds", []);
        this.set("search/levels", []);
        this.set("search/levels_id", '');
        this.set("search/levels_name", '');
        this.set("search/levels_itens", false);
        this.set("search/levels_itens_id", '');
        this.set("search/levels_itens_name", '');
        this.set("search/levels_sons", '');
        this.set("search/is_document_favorite", false);
        this.set("search/favorite_list", []);
        this.set("search/favorite_list_ids", []);
        this.set("search/search_in_folder", false);
        this.set("search/levels_father_name", false);
        this.set("search/levels_father_id", false);
    },
    resetFilters() {
        this.set("search/filters", DEFAULT_FILTERS);
    }
};

const formatDate = value => {
    if (!isString(value)) {
        return null;
    }

    return value
        .split("/")
        .reverse()
        .join("-");
};

const getTranscription = (...contents) => {
    let transcription = "";

    for (const content of contents) {
        if (!isEmpty(content)) {
            transcription = content;
            break;
        }
    }

    return transcription;
};

export default { state, mutations, actions };
